// import React, {
//   useMemo,
//   useState,
//   useEffect,
//   useRef,
//   useCallback,
// } from "react";
// import { ProgressBar, Spinner, Button } from "react-bootstrap";
// import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router-dom";
// import { Assets_URL } from "../../Apicongfig";

// const UserRoadmap = ({
//   isLoading = false,
//   progress = 0,
//   data = null,
//   startDate,
//   endDate,
//   onPrevious,
//   onNext,
//   onReset,
// }) => {
//   console.log("data", data);
//   const [t] = useTranslation("global");
//   const navigate = useNavigate();
//   const [currentDate, setCurrentDate] = useState(new Date());

//   const [isNavigating, setIsNavigating] = useState(false);

//   const handleNavigation = useCallback(
//     (navigationFn) => {
//       if (isNavigating) return;
//       setIsNavigating(true);
//       navigationFn();
//       setTimeout(() => setIsNavigating(false), 300);
//     },
//     [isNavigating]
//   );

//   useEffect(() => {
//     const timer = setInterval(() => setCurrentDate(new Date()), 86400000);
//     return () => clearInterval(timer);
//   }, []);

//   const parseDate = (dateString) => {
//     if (!dateString) return new Date();
//     // Handle both "YYYY-MM-DD" and "YYYY-MM-DDTHH:MM:SS" formats
//     if (dateString.includes("T")) {
//       return new Date(dateString);
//     }
//     const [year, month, day] = dateString.split("-");
//     return new Date(year, month - 1, day);
//   };

//   const currentDatePosition = useMemo(() => {
//     const chartStart = new Date(startDate);
//     const chartEnd = new Date(endDate);
//     const totalDuration = chartEnd - chartStart;
//     const elapsed = currentDate - chartStart;
//     return (elapsed / totalDuration) * 100;
//   }, [currentDate, startDate, endDate]);

//   const { monthHeaders, monthDividers } = useMemo(() => {
//     const headers = [];
//     const dividers = [];
//     const current = new Date(startDate);
//     const end = new Date(endDate);

//     headers.push(new Date(current));

//     const clientColumnWidth = 200;
//     const totalWidth = window.innerWidth * 0.9;
//     const clientColumnPercent = (clientColumnWidth / totalWidth) * 100;

//     while (current < end) {
//       const nextMonth = new Date(current);
//       nextMonth.setMonth(nextMonth.getMonth() + 1);

//       if (nextMonth > end) break;

//       headers.push(new Date(nextMonth));

//       const daysIntoPeriod = (nextMonth - startDate) / (1000 * 60 * 60 * 24);
//       const totalDays = (endDate - startDate) / (1000 * 60 * 60 * 24);
//       const dividerPos =
//         clientColumnPercent +
//         (daysIntoPeriod / totalDays) * (100 - clientColumnPercent);

//       dividers.push(dividerPos);
//       current.setMonth(current.getMonth() + 1);
//     }

//     return { monthHeaders: headers, monthDividers: dividers };
//   }, [startDate, endDate]);

//   const displayUsers = useMemo(() => {
//     if (!data || !data.users) return [];

//     return data.users.map((user) => ({
//       id: user.id,
//       name: user.full_name,
//       avatar: user.image,
//       completed_meeting_count: user.completed_meeting_count,
//       meetings: user.meetings || [],
//     }));
//   }, [data]);

//   const getMeetingStatusColor = (meeting) => {
//     if (meeting?.status === "closed") return "rgb(119, 214, 113)";
//     if (meeting?.status === "to_finish") return "#ff9800";
//     if (meeting?.status === "todo") return "#6c757d";
//     if (meeting?.status === "abort") return "rgb(119, 19, 241)";
//     if (meeting?.status === "in_progress" && meeting?.meeting_delay === false)
//       return "#f2db43";
//     if (meeting?.status === "in_progress" && meeting?.meeting_delay === true)
//       return "red";
//     if (meeting?.status === "active") return "rgb(91, 170, 234)";
//     return "#4e79a7";
//   };

//   const calculateCompletionPercentage = (steps) => {
//     if (!Array.isArray(steps) || steps.length === 0) return 0;

//     const totalSteps = steps?.length;
//     const completedSteps = steps.filter(
//       (step) => step.step_status === "completed"
//     ).length;

//     return Math.round((completedSteps / totalSteps) * 100);
//   };

//   const calculateMeetingPosition = (meeting) => {
//     console.log("meeting", meeting);
//     const start = parseDate(meeting.date);
//     const end =
//       meeting?.status === "abort"
//         ? parseDate(meeting.abort_end_time?.split(" ")[0])
//         : parseDate(meeting.estimate_time?.split("T")[0] || meeting.end_date);

//     const chartStart = new Date(startDate);
//     const chartEnd = new Date(endDate);

//     const effectiveStart = start < chartStart ? chartStart : start;
//     const effectiveEnd = end > chartEnd ? chartEnd : end;

//     const totalDuration = chartEnd - chartStart;
//     let startPos =
//       Math.max(0, (effectiveStart - chartStart) / totalDuration) * 100;
//     let endPos =
//       Math.min(100, (effectiveEnd - chartStart) / totalDuration) * 100;

//     let width = endPos - startPos;
//     const MIN_WIDTH = 2;
//     if (width < MIN_WIDTH) {
//       const center = (startPos + endPos) / 2;
//       startPos = center - MIN_WIDTH / 2;
//       endPos = center + MIN_WIDTH / 2;
//       width = MIN_WIDTH;
//     }
//     const completionPercentage = calculateCompletionPercentage(
//       meeting?.steps || []
//     );
//     console.log("completionPercentage", completionPercentage);

//     return {
//       left: `${startPos}%`,
//       width: `${width}%`,
//       color: getMeetingStatusColor(meeting),
//       completedWidth: `${completionPercentage}%`,
//       percentage: completionPercentage,
//     };
//   };

//   return (
//     <div className="gantt-container">
//       <div className="roadmap-navigation" style={{ marginBottom: "10px" }}>
//         {/* Mobile layout (stacked) */}
//         <div className="d-block d-md-none">
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               marginBottom: "8px",
//             }}
//           >
//             <Button
//               variant="outline-secondary"
//               onClick={onReset}
//               size="sm"
//               style={{ marginRight: "8px", flex: 1 }}
//               disabled={isNavigating}
//             >
//               {t("calendar.reset")}
//             </Button>
//             <Button
//               className="btn-nxt-pre"
//               onClick={() => handleNavigation(onPrevious)}
//               disabled={isNavigating}
//               size="sm"
//               style={{ marginRight: "8px", flex: 1 }}
//             >
//               {t("calendar.prev")}
//             </Button>
//             <Button
//               className="btn-nxt-pre"
//               onClick={() => handleNavigation(onNext)}
//               disabled={isNavigating}
//               size="sm"
//               style={{ flex: 1 }}
//             >
//               {t("calendar.next")}
//             </Button>
//           </div>
//           <div
//             style={{
//               textAlign: "center",
//               fontWeight: "bold",
//               fontSize: "14px",
//             }}
//           >
//             {startDate.toLocaleDateString(t("calendar.locale"), {
//               month: "short",
//               year: "numeric",
//             })}{" "}
//             -{" "}
//             {endDate.toLocaleDateString(t("calendar.locale"), {
//               month: "short",
//               year: "numeric",
//             })}
//           </div>
//         </div>

//         {/* Desktop layout (original) */}
//         <div
//           className="d-none d-md-flex"
//           style={{ justifyContent: "space-between", padding: "0 10px" }}
//         >
//           <div>
//             <Button
//               variant="outline-secondary"
//               onClick={onReset}
//               style={{ marginRight: "10px" }}
//             >
//               {t("calendar.reset")}
//             </Button>
//             <span style={{ fontWeight: "bold" }}>
//               {startDate.toLocaleDateString(t("calendar.locale"), {
//                 month: "long",
//                 year: "numeric",
//               })}{" "}
//               -{" "}
//               {endDate.toLocaleDateString(t("calendar.locale"), {
//                 month: "long",
//                 year: "numeric",
//               })}
//             </span>
//           </div>
//           <div>
//             <Button className="btn-nxt-pre me-2" onClick={onPrevious}>
//               {t("calendar.prev")}
//             </Button>
//             <Button className="btn-nxt-pre" onClick={onNext}>
//               {t("calendar.next")}
//             </Button>
//           </div>
//         </div>
//       </div>

//       <div className="gantt-scroll-wrapper">
//         {/* Current date indicator */}
//         <div
//           className="current-date-line"
//           style={{
//             left: `calc(200px + (100% - 200px) * ${currentDatePosition / 100})`,
//           }}
//         />

//         <div className="gantt-header gantt-row">
//           <div className="gantt-cell gantt-client-header">Team Members</div>
//           {monthHeaders.map((month, index) => (
//             <div key={index} className="gantt-cell gantt-month-header">
//               {month.toLocaleString("default", { month: "short" })}{" "}
//               {month.getFullYear().toString().slice(-2)}
//             </div>
//           ))}
//         </div>

//         {/* Month divider lines */}
//         {monthDividers.map((pos, index) => (
//           <div
//             key={`divider-${index}`}
//             className="month-divider"
//             style={{ left: `${pos}%` }}
//           />
//         ))}

//         {/* User and meeting rows */}
//         {displayUsers.map((user) => {
//           const userMeetings = user.meetings.filter((meeting) => {
//             if (!meeting.date) return false;

//             const start = parseDate(meeting.date);
//             const end = meeting.end_date ? parseDate(meeting.end_date) : start;
//             const chartStart = new Date(startDate);
//             const chartEnd = new Date(endDate);

//             return (
//               (start >= chartStart && start <= chartEnd) ||
//               (end >= chartStart && end <= chartEnd) ||
//               (start <= chartStart && end >= chartEnd)
//             );
//           });

//           const meetingGroups = [];
//           userMeetings.forEach((meeting) => {
//             const position = calculateMeetingPosition(meeting);
//             let placed = false;

//             for (let group of meetingGroups) {
//               const overlaps = group.some((existingMeeting) => {
//                 const existingPos = calculateMeetingPosition(existingMeeting);
//                 return !(
//                   parseFloat(position.left) >=
//                     parseFloat(existingPos.left) +
//                       parseFloat(existingPos.width) ||
//                   parseFloat(position.left) + parseFloat(position.width) <=
//                     parseFloat(existingPos.left)
//                 );
//               });

//               if (!overlaps) {
//                 group.push(meeting);
//                 placed = true;
//                 break;
//               }
//             }

//             if (!placed) {
//               meetingGroups.push([meeting]);
//             }
//           });

//           return (
//             // In the displayUsers.map section, replace the meeting grouping logic with this:

//             <div key={user.id} className="gantt-row">
//               <div className="gantt-cell gantt-client-name">
//                 <div className="client-avatar-container">
//                   {user.avatar ? (
//                     <img
//                       src={
//                         user.avatar?.startsWith("http")
//                           ? user.avatar
//                           : Assets_URL + "/" + user.avatar
//                       }
//                       alt={user.name}
//                       onClick={() => navigate(`/user/${user.id}`)}
//                       style={{
//                         cursor: "pointer",
//                         objectFit: "cover",
//                         width: "30px",
//                         height: "30px",
//                         objectPosition: "top",
//                         borderRadius: "50%",
//                       }}
//                     />
//                   ) : (
//                     <div className="client-avatar-placeholder" />
//                   )}
//                   <span>
//                     {user.name} ({user.completed_meeting_count}/
//                     {user.meetings.length})
//                   </span>
//                 </div>
//               </div>
//               <div
//                 className="gantt-cell gantt-mission-track"
//                 style={{ minHeight: `${userMeetings.length * 30 + 10}px` }}
//               >
//                 {userMeetings.map((meeting, index) => {
//                   const position = calculateMeetingPosition(meeting);
//                   return (
//                     <div
//                       key={meeting.id}
//                       className="gantt-mission-container"
//                       style={{
//                         left: position.left,
//                         width: position.width,
//                         top: `${index * 30}px`,
//                         zIndex: index + 1,
//                       }}
//                       onClick={() => {
//                         if (
//                           meeting?.status === "closed" ||
//                           meeting?.status === "abort"
//                         ) {
//                           navigate(`/present/invite/${meeting?.id}`);
//                         } else {
//                           navigate(`/invite/${meeting?.id}`);
//                         }
//                       }}
//                     >
//                       <div
//                         className="gantt-mission-bar"
//                         style={{
//                           width: "100%",
//                           backgroundColor: position.color,
//                           opacity: 0.3,
//                         }}
//                       />
//                       <div
//                         className="gantt-mission-completed"
//                         style={{
//                           width: position.completedWidth,
//                           backgroundColor: position.color,
//                         }}
//                       />
//                       <div
//                         className="gantt-mission-label"
//                         title={`${meeting.title} (${meeting.date}${
//                           meeting.end_date ? ` to ${meeting.end_date}` : ""
//                         }) - ${position.percentage}% completed`}
//                       >
//                         {meeting.title} ({position.percentage}%)
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default UserRoadmap;

import React, {
  useMemo,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { ProgressBar, Spinner, Button, Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Assets_URL } from "../../Apicongfig";

const UserRoadmap = ({
  isLoading = false,
  progress = 0,
  data = null,
  startDate,
  endDate,
  onPrevious,
  onNext,
  onReset,
}) => {
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [isNavigating, setIsNavigating] = useState(false);
  const [expandedUsers, setExpandedUsers] = useState({});
  const [ledgerVisible, setLedgerVisible] = useState(true);

  const toggleUserExpansion = (userId) => {
    setExpandedUsers((prev) => ({
      ...prev,
      [userId]: !prev[userId],
    }));
  };

  const handleNavigation = useCallback(
    (navigationFn) => {
      if (isNavigating) return;
      setIsNavigating(true);
      navigationFn();
      setTimeout(() => setIsNavigating(false), 300);
    },
    [isNavigating]
  );
  

  useEffect(() => {
    const timer = setInterval(() => setCurrentDate(new Date()), 86400000);
    return () => clearInterval(timer);
  }, []);

  const parseDate = (dateString) => {
    if (!dateString) return new Date();
    if (dateString.includes("T")) {
      return new Date(dateString);
    }
    const [year, month, day] = dateString.split("-");
    return new Date(year, month - 1, day);
  };

  // const currentDatePosition = useMemo(() => {
  //   const chartStart = new Date(startDate);
  //   const chartEnd = new Date(endDate);
  //   const totalDuration = chartEnd - chartStart;
  //   const elapsed = currentDate - chartStart;
  //   return (elapsed / totalDuration) * 100;
  // }, [currentDate, startDate, endDate]);
   const currentDatePosition = useMemo(() => {
   const chartStart = new Date(startDate);
    const chartEnd = new Date(endDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (today <= chartStart) return 0;
    if (today >= chartEnd) return 100;

    const totalDuration = chartEnd - chartStart;
    const elapsed = today - chartStart;
    return parseFloat(((elapsed / totalDuration) * 100).toFixed(2));
  }, [startDate, endDate]);
  const { weekHeaders, weekDividers } = useMemo(() => {
    const headers = [];
    const dividers = [];
    const current = new Date(startDate);
    const end = new Date(endDate);

    const clientColumnWidth = 200;
    const totalWidth = window.innerWidth * 0.9;
    const clientColumnPercent = (clientColumnWidth / totalWidth) * 100;

    // Add first week header
    headers.push(new Date(current));

    // Add 3 more week headers (total 4 weeks)
    for (let i = 0; i < 3; i++) {
      const nextWeek = new Date(current);
      nextWeek.setDate(nextWeek.getDate() + 7);

      if (nextWeek > end) break;

      headers.push(new Date(nextWeek));

      const daysIntoPeriod = (nextWeek - startDate) / (1000 * 60 * 60 * 24);
      const totalDays = (endDate - startDate) / (1000 * 60 * 60 * 24);
      const dividerPos =
        clientColumnPercent +
        (daysIntoPeriod / totalDays) * (100 - clientColumnPercent);

      dividers.push(dividerPos);
      current.setDate(current.getDate() + 7);
    }

    return { weekHeaders: headers, weekDividers: dividers };
  }, [startDate, endDate]);
  const displayUsers = useMemo(() => {
    if (!data || !data.users) return [];

    return data.users.map((user) => ({
      id: user.id,
      name: user.full_name || `${user.name} ${user.last_name}`,
      avatar: user.image,
      destinations: user.destinations || [],
    }));
  }, [data]);

  const getMeetingStatusColor = (meeting) => {
    if (meeting?.status === "closed") return "rgb(119, 214, 113)";
    if (meeting?.status === "to_finish") return "#ff9800";
    if (meeting?.status === "todo") return "#6c757d";
    if (meeting?.status === "abort") return "rgb(119, 19, 241)";
    if (meeting?.status === "in_progress" && meeting?.meeting_delay === false)
      return "#f2db43";
    if (meeting?.status === "in_progress" && meeting?.meeting_delay === true)
      return "red";
    if (meeting?.status === "active") return "rgb(91, 170, 234)";
    return "#4e79a7";
  };

  const calculateCompletionPercentage = (steps) => {
    if (!Array.isArray(steps) || steps.length === 0) return 0;

    const totalSteps = steps?.length;
    const completedSteps = steps.filter(
      (step) => step.step_status === "completed"
    ).length;

    return Math.round((completedSteps / totalSteps) * 100);
  };

  const calculateMeetingPosition = (meeting) => {
    const start = parseDate(meeting.date);
    const end =
      meeting?.status === "abort"
        ? parseDate(meeting.abort_end_time?.split(" ")[0])
        : parseDate(meeting.estimate_time?.split("T")[0] || meeting.end_date);

    const chartStart = new Date(startDate);
    const chartEnd = new Date(endDate);

    const effectiveStart = start < chartStart ? chartStart : start;
    const effectiveEnd = end > chartEnd ? chartEnd : end;

    const totalDuration = chartEnd - chartStart;
    let startPos =
      Math.max(0, (effectiveStart - chartStart) / totalDuration) * 100;
    let endPos =
      Math.min(100, (effectiveEnd - chartStart) / totalDuration) * 100;

    let width = endPos - startPos;
    const MIN_WIDTH = 2;
    if (width < MIN_WIDTH) {
      const center = (startPos + endPos) / 2;
      startPos = center - MIN_WIDTH / 2;
      endPos = center + MIN_WIDTH / 2;
      width = MIN_WIDTH;
    }
    const completionPercentage = calculateCompletionPercentage(
      meeting?.steps || []
    );

    return {
      left: `${startPos}%`,
      width: `${width}%`,
      color: getMeetingStatusColor(meeting),
      completedWidth: `${completionPercentage}%`,
      percentage: completionPercentage,
    };
  };

    const statuses = [
      { name: t("calendar.status1"), color: "rgb(119 214 113)" },
      { name: t("calendar.status2"), color: "yellow" },
      { name: t("calendar.status3"), color: "red" },
      { name: t("calendar.status4"), color: "rgb(119 19 241)" },
      { name: t("calendar.status5"), color: "rgb(91 170 234)" },
      { name: t("calendar.status6"), color: "#ff9800" },
    ];
  

  return (
    <div className="gantt-container">
      {/* Navigation Controls */}
      <div className="roadmap-navigation" style={{ marginBottom: "10px" }}>
        {/* Mobile layout (stacked) */}
        <div className="d-block d-md-none">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "8px",
            }}
          >
            <Button
              variant="outline-secondary"
              onClick={onReset}
              size="sm"
              style={{ marginRight: "8px", flex: 1 }}
              disabled={isNavigating}
            >
              {t("calendar.reset")}
            </Button>
            <Button
              className="btn-nxt-pre"
              onClick={() => handleNavigation(onPrevious)}
              disabled={isNavigating}
              size="sm"
              style={{ marginRight: "8px", flex: 1 }}
            >
              {t("calendar.prev")}
            </Button>
            <Button
              className="btn-nxt-pre"
              onClick={() => handleNavigation(onNext)}
              disabled={isNavigating}
              size="sm"
              style={{ flex: 1 }}
            >
              {t("calendar.next")}
            </Button>
          </div>
          <div
            style={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "14px",
            }}
          >
            Week 1 -{" "}
            {startDate.toLocaleDateString(t("calendar.locale"), {
              month: "short",
              day: "numeric",
            })}{" "}
            to{" "}
            {new Date(
              startDate.getTime() + 6 * 24 * 60 * 60 * 1000
            ).toLocaleDateString(t("calendar.locale"), {
              month: "short",
              day: "numeric",
            })}
          </div>
        </div>

        {/* Desktop layout (original) */}
        <div
          className="d-none d-md-flex"
          style={{ justifyContent: "space-between", padding: "0 10px" }}
        >
          <div>
            <Button
              variant="outline-secondary"
              onClick={onReset}
              style={{ marginRight: "10px" }}
            >
              {t("calendar.reset")}
            </Button>
            {/* <Button
              variant="outline-info"
              onClick={() => setLedgerVisible(!ledgerVisible)}
              style={{ marginRight: "10px" }}
            >
              {ledgerVisible ? "Hide Legend" : "Show Legend"}
            </Button> */}
            <span style={{ fontWeight: "bold" }}>
              {startDate.toLocaleDateString(t("calendar.locale"), {
                month: "long",
                year: "numeric",
              })}{" "}
              -{" "}
              {endDate.toLocaleDateString(t("calendar.locale"), {
                month: "long",
                year: "numeric",
              })}
            </span>
          </div>
          <div>
            <Button className="btn-nxt-pre me-2" onClick={onPrevious}>
              {t("calendar.prev")}
            </Button>
            <Button className="btn-nxt-pre" onClick={onNext}>
              {t("calendar.next")}
            </Button>
          </div>
        </div>
      </div>

      <div className="gantt-scroll-wrapper">
        {/* Current date indicator */}
        <div
          className="current-date-line"
          style={{
            left: `calc(200px + (100% - 200px) * ${currentDatePosition / 100})`,
          }}
        />

        <div className="gantt-header gantt-row">
          <div
            className="gantt-cell gantt-client-header"
            // style={{ width: "250px" }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <span>Team Members</span>
            </div>
          </div>
          {weekHeaders.map((weekStart, index) => {
            const weekEnd = new Date(weekStart);
            weekEnd.setDate(weekEnd.getDate() + 6); // Add 6 days to get end of the week

                // Get ISO week number
                const getISOWeekNumber = (date) => {
                  const d = new Date(date);
                  d.setHours(0, 0, 0, 0);
                  d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7));
                  const week1 = new Date(d.getFullYear(), 0, 4);
                  return (
                    1 +
                    Math.round(
                      ((d - week1) / 86400000 -
                        3 +
                        ((week1.getDay() + 6) % 7)) /
                        7
                    )
                  );
                };

                const weekNumber = getISOWeekNumber(weekStart);

                const locale = t("calendar.locale");
                const startDay = weekStart.getDate();
                const startMonth = weekStart.toLocaleDateString(locale, {
                  month: "short",
                });
                const endDay = weekEnd.getDate();
                const endMonth = weekEnd.toLocaleDateString(locale, {
                  month: "short",
                });


            return (
              <div key={index} className="gantt-cell gantt-month-header">
                {t("week")} {index + 1}
                <br />
                {startDay} {startMonth} - {endDay} {endMonth}
              </div>
            );
          })}
        </div>

        {/* Month divider lines */}
        {weekDividers.map((pos, index) => (
          <div
            key={`divider-${index}`}
            className="month-divider"
            style={{ left: `${pos}%` }}
          />
        ))}
        {/* User rows with their destinations */}
        {displayUsers.map((user) => {
          const allMeetings = user.destinations.reduce((acc, destination) => {
            return [...acc, ...(destination.meetings || [])];
          }, []);

          return (
            <React.Fragment key={user.id}>
              {/* User row */}
              <div className="gantt-row">
                <div
                  className="gantt-cell gantt-client-name"
                  // style={{ width: "250px" }}
                >
                  <div
                    className="client-avatar-container"
                    style={{
                      cursor: "pointer",
                      padding: "8px",
                      borderRadius: "4px",
                      backgroundColor: expandedUsers[user.id]
                        ? "#f0f0f0"
                        : "transparent",
                      transition: "background-color 0.2s",
                    }}
                    onClick={() => toggleUserExpansion(user.id)}
                  >
                    <div className="d-flex align-items-center">
                      {user.avatar ? (
                        <img
                          src={
                            user.avatar?.startsWith("http")
                              ? user.avatar
                              : Assets_URL + "/" + user.avatar
                          }
                          alt={user.name}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/member/${user.id}`);
                          }}
                          style={{
                            cursor: "pointer",
                            objectFit: "cover",
                            width: "40px",
                            height: "40px",
                            objectPosition: "top",
                            borderRadius: "50%",
                            marginRight: "12px",
                            border: "2px solid #fff",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          }}
                        />
                      ) : (
                        <div
                          className="client-avatar-placeholder"
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            backgroundColor: "#e9ecef",
                            marginRight: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#6c757d",
                            fontWeight: "bold",
                            fontSize: "16px",
                          }}
                        >
                          {user.name.charAt(0).toUpperCase()}
                        </div>
                      )}
                      <div>
                        <div style={{ fontWeight: "500" }}>{user.name}</div>
                        <div
                          className="text-muted"
                          style={{ fontSize: "0.8rem" }}
                        >
                          {allMeetings.length} moments •{" "}
                          {user.destinations.length} missions
                        </div>
                      </div>
                      <div style={{ marginLeft: "auto" }}>
                        <i
                          className={`bi bi-chevron-${
                            expandedUsers[user.id] ? "up" : "down"
                          }`}
                          style={{ color: "#6c757d" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="gantt-cell gantt-mission-track">
                  {/* This space intentionally left blank for the user row */}
                </div>
              </div>

              {/* Destinations for this user (shown if expanded) */}
              {user.destinations.map((destination) => {
                const destinationMeetings = destination.meetings.filter(
                  (meeting) => {
                    if (!meeting.date) return false;

                    const start = parseDate(meeting.date);
                    const end = meeting.end_date
                      ? parseDate(meeting.end_date)
                      : start;
                    const chartStart = new Date(startDate);
                    const chartEnd = new Date(endDate);

                    return (
                      (start >= chartStart && start <= chartEnd) ||
                      (end >= chartStart && end <= chartEnd) ||
                      (start <= chartStart && end >= chartEnd)
                    );
                  }
                );

                return (
                  <div
                    key={`${user.id}-${destination.id}`}
                    className="gantt-row"
                    style={{
                      backgroundColor: "rgba(245, 245, 245, 0.5)",
                      borderLeft: "4px solid #6c757d",
                    }}
                  >
                    <div
                      className="gantt-cell gantt-client-name"
                      style={{ width: "250px" }}
                    >
                      <div
                        className="client-avatar-container"
                        style={{
                          paddingLeft: "52px",
                          padding: "8px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <span
                            style={{ fontWeight: "500", cursor: "pointer" }}
                            onClick={() => {
                              navigate(`/invitiesToMeeting/${destination?.id}`);
                            }}
                          >
                            {destination.destination_name}
                          </span>
                          <div
                            className="text-muted"
                            style={{ fontSize: "0.8rem" }}
                          >
                            {destinationMeetings.length} moments
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="gantt-cell gantt-mission-track"
                      style={{
                        minHeight: `${destinationMeetings.length * 30 + 10}px`,
                      }}
                    >
                      {destinationMeetings.map((meeting, index) => {
                        const position = calculateMeetingPosition(meeting);
                        return (
                          <div
                            key={meeting.id}
                            className="gantt-mission-container"
                            style={{
                              left: position.left,
                              width: position.width,
                              top: `${index * 30}px`,
                              zIndex: index + 1,
                            }}
                            onClick={() => {
                              if (
                                meeting?.status === "closed" ||
                                meeting?.status === "abort"
                              ) {
                                navigate(`/present/invite/${meeting?.id}`);
                              } else {
                                navigate(`/invite/${meeting?.id}`);
                              }
                            }}
                          >
                            <div
                              className="gantt-mission-bar"
                              style={{
                                width: "100%",
                                backgroundColor: position.color,
                                opacity: 0.3,
                              }}
                            />
                            <div
                              className="gantt-mission-completed"
                              style={{
                                width: position.completedWidth,
                                backgroundColor: position.color,
                              }}
                            />
                            <div
                              className="gantt-mission-label"
                              title={`${meeting.title} (${meeting.date}${
                                meeting.end_date
                                  ? ` to ${meeting.end_date}`
                                  : ""
                              }) - ${position.percentage}% completed`}
                            >
                              {meeting.title} ({position.percentage}%)
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </React.Fragment>
          );
        })}
      </div>

     <div className="status-legend">
             <div className="status-list">
               {statuses.map((status, index) => (
                 <div key={index} className="status-item">
                   <span
                     className="status-dot"
                     style={{ backgroundColor: status.color }}
                   ></span>
                   {status.name}
                 </div>
               ))}
             </div>
           </div>
    </div>
  );
};

export default UserRoadmap;
